import { Dispatch, FC, Fragment, HTMLAttributes, SetStateAction } from "react";
import { isEmpty } from "lodash";
import clsx from "clsx";

// ----------------------------------------------------------------------------

export type IListWithHeadingProps = HTMLAttributes<HTMLDivElement> & {
  heading?: string;
  items?: (string | undefined)[];
  // Multiselect: Please remove and uncomment below lines
  activeValue?: string;
  setActiveValue?: Dispatch<SetStateAction<string>>;
  // activeValue?: string[];
  // setActiveValue?: Dispatch<SetStateAction<string[]>>;
  scrollToSection?: () => void;
};

const ListWithHeading: FC<IListWithHeadingProps> = (props) => {
  const {
    heading,
    items,
    activeValue,
    setActiveValue,
    scrollToSection,
    className,
    ...other
  } = props;

  if (!heading && (!items || isEmpty(items))) return;

  const handleClick = (value: string) => {
    // Multiselect: Please remove and uncomment below lines
    setActiveValue && setActiveValue(value);
    scrollToSection && scrollToSection();
    // setActiveValue &&
    //   setActiveValue((current) =>
    //     current.includes(value)
    //       ? current.filter((v) => v !== value)
    //       : [...current, value],
    //   );
    // scrollToSection && scrollToSection();
  };

  return (
    <div className={clsx("w-full", className)} {...other}>
      {heading && (
        <h3
          className={clsx(
            "break-words text-h6 font-medium text-blue-900 md:mt-0 lg:text-h5",
          )}
        >
          {heading}
        </h3>
      )}

      {items && items.length > 0 && (
        <ul
          className={clsx(
            "flex flex-col gap-2 md:gap-4",
            heading && "mt-2 md:mt-4",
          )}
        >
          {items.map((it, id) => (
            <Fragment key={id}>
              {it && (
                <p
                  className={clsx(
                    "w-fit cursor-pointer text-base text-black-900 hover:text-secondary-900",
                    // Multiselect: Please remove and uncomment below lines
                    activeValue === it && "text-secondary-900",
                    // activeValue?.includes(it) && "text-secondary-900",
                  )}
                  onClick={() => handleClick(it)}
                >
                  {it}
                </p>
              )}
            </Fragment>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ListWithHeading;
